import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Input() text: string;
  @Input() headline: string;
  @Input() customButton: boolean;
  @Input() customButtonText: string;
  @Input() customButtonLink: string;

  close = false;

  constructor() { }

  ngOnInit(): void {
  }


  closePopup() {
    this.close = true;
  }

  openLink() {
    window.open(this.customButtonLink, '_blank');
  }

}
